document.addEventListener('submit', function (btn) {
    const form = btn.target.closest('form');
    if (form.classList.contains('form')) {
        btn.preventDefault();

        const formData = new FormData(form);
        document.querySelector('.button-form').disabled = true;
        fetch('/local/ajax/callback.php', {
            method: 'POST',
            body: formData
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.status) {
                    form.reset();
                    if (document.querySelectorAll('.mfp-close').length > 0) {
                        document.querySelector('.mfp-close').dispatchEvent(new Event('click', {bubbles : true, cancelable : true}));
                    }
                    document.querySelector('.form-alert').style.display = 'block';
                } else {
                    document.querySelector('.form-alert span').innerHTML = data.message;
                    document.querySelector('.form-alert').style.display = 'block';
                }
                document.querySelector('.button-form').disabled = false;
            });
    }
});